import { Box, IconButton, useMediaQuery } from '@mui/material'
import React from 'react'
import logo from './../../../assets/images/footer-logo.png'
import logo_mobile from './../../../assets/images/footer-logo-mobile.png'
import facebook from './../../../assets/images/facebook-footer-icon.png'
import linkedin from './../../../assets/images/linkedin-footer-icon.png'
import instagram from './../../../assets/images/instagram-footer-icon.png'
import twitter from './../../../assets/images/twitter-footer-icon.png'
import youtube from './../../../assets/images/youtube-footer-icon.png'
import { useTheme } from '@mui/material/styles'
import { Link } from 'react-router-dom'
import { LINKS } from '../../../utils/constants/links'

const socialConfig = [
  { id: 0, link: LINKS.FACEBOOK, icon: facebook, width: '34px', height: '34px', widthMobile: '29px', heightMobile: '28px' },
  { id: 1, link: LINKS.LINKEDIN, icon: linkedin, width: '33px', height: '33px', widthMobile: '28px', heightMobile: '27px' },
  { id: 2, link: LINKS.INSTAGRAM, icon: instagram, width: '31px', height: '31px', widthMobile: '27px', heightMobile: '27px' },
  { id: 3, link: LINKS.TWITTER, icon: twitter, width: '26px', height: '26px', widthMobile: '22px', heightMobile: '22px' },
  { id: 4, link: LINKS.YOUTUBE, icon: youtube, width: '39px', height: '39px', widthMobile: '33px', heightMobile: '33px' }
]

const Footer = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'))
  return <footer style={{
    background: '#EEEFF4',
    height: isMobile ? '187px' : '212px',
    position: 'relative',
    overflow: 'hidden'
  }}>
        {isMobile
          ? <Box sx={{
            position: 'absolute',
            top: '9px',
            left: '50%',
            height: '170px',
            width: '176px',
            transform: 'translate(-50%, 0)'
          }} component='img' src={logo_mobile}/>
          : <Box sx={{
            position: 'absolute',
            top: '0',
            right: '26%',
            width: '298px',
            height: '212px'
          }} component='img' src={logo}/>
        }
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: isMobile ? 'center' : 'start',
          width: isMobile ? '100%' : 'auto',
          gap: isMobile ? '32px' : '25px',
          marginTop: isMobile ? '32px' : '61px',
          marginLeft: isMobile ? '0' : '58px'
        }}>
      {socialConfig.map(el => <Link style={{ flexShrink: 0 }} key={el.id} to={el.link} target='_blank'>
          <IconButton
              size="small"
              aria-label="facebook social "
              aria-controls="social network"
              aria-haspopup="true"
          >
              <Box sx={{
                width: isMobile ? el.widthMobile : el.width,
                height: isMobile ? el.heightMobile : el.height
              }} component='img' src={el.icon}/>
          </IconButton>
      </Link>)}
        </Box>
      <Box sx={{
        display: 'flex',
        justifyContent: isMobile ? 'center' : 'start',
        position: 'relative',
        gap: isMobile ? '31px' : '47px',
        marginLeft: isMobile ? '0' : '63px',
        marginTop: isMobile ? '32px' : '37px',
        fontSize: '12px',
        fontWeight: '500',
        lineHeight: '20px',
        color: '#8C96A8',
        flexWrap: 'wrap'

      }}>

          <Box>Agent Elite, Inc © 2023</Box>
          <Box><a style={{
            textDecoration: 'none',
            color: '#8C96A8'
          }} href={LINKS.TERMS_AND_CONDITIONS} target='_blank' rel="noreferrer">Agent Elite, Inc. Terms & Conditions</a></Box>
          <Box><a style={{
            textDecoration: 'none',
            color: '#8C96A8'
          }} href={LINKS.PRIVACY_POLICY} target='_blank' rel="noreferrer">Privacy Policy</a></Box>
      </Box>
    </footer>
}

export default Footer
